import { RepoObjectInput } from "../../../backend/executionTypes";
import { PmxActivity, Repo } from "../../../backend/types";
import { getFileNameAndRepoName } from "./fileHelper";

export const setExecutionSettingRecommendation = (
  notCloneJob: boolean,
  environmentType: string,
  setExecutionImage: any,
  setCustomCommand: any,
  setExecutionInput: any,
  getCommandRecommendation: any,
  getImageRecommendation: any,
  getExecutionInputRecommendation: any,
  variables: {
    activityId?: number;
    environmentId?: string;
    path?: string;
    entrypoint?: RepoObjectInput;
  },
  activityData: PmxActivity,
  callRepositoryObjects?: Function
) => {
  if (environmentType === "phil" && callRepositoryObjects) {
    const repositories: Repo[] = [
      ...(Array.isArray(activityData.readOnlyRepositories)
        ? activityData.readOnlyRepositories.filter(
            (repo: Repo | null | undefined): repo is Repo => !!repo
          )
        : []),
      activityData.mainRepository
    ];

    getExecutionInputRecommendation({
      variables: variables
    }).then(({ data }: any) => {
      // always main activity
      const dataInputs = data.getInputRecommendations.inputs;
      const inputsRepositoryObjects: any = [];
      Promise.all(
        dataInputs.map(async (input: string) => {
          let location = input;
          const segments = input.split("/").filter((x) => x !== "");
          let name: string = location;
          let repoName: string = "";
          if (segments.length > 1) {
            name = segments.pop()!;
            repoName = segments[0];
            location = segments.slice(1).join("/");
          }
          const repoId = repositories.find((repo) => repo.name === repoName)
            ?.id;

          const { data }: any = await callRepositoryObjects({
            variables: {
              repoId: repoId,
              location: location !== input ? location : "/",
              name
            }
          });
          const file = data.getRepositoryObjects.repositoryObjects[0];
          inputsRepositoryObjects.push({
            repositoryId: file.repository.id,
            absolutePath: file.repository.name + "/" + file.name,
            name: file.name,
            notFound: false,
            versionId: file.versionId
          });
        })
      ).then(() => {
        if (inputsRepositoryObjects.length > 0) {
          setExecutionInput(inputsRepositoryObjects);
        }
      });
    });

    if (notCloneJob) {
      getImageRecommendation({
        variables: {
          activityId: variables.activityId,
          entrypoint: variables.entrypoint
        }
      }).then(({ data }: any) => {
        if (data.getImageRecommendations.images.length > 0) {
          const image = data.getImageRecommendations.images[0].id.toString();
          setExecutionImage({ id: image });
          setCustomCommand(getCommandRecommendation(image));
        }
      });
    }
  } else {
    const [repoName, fileName] = getFileNameAndRepoName(variables.path);
    getExecutionInputRecommendation({
      variables: {
        environmentId: variables.environmentId,
        repoName: repoName,
        path: fileName
      }
    }).then(({ data }: any) => {
      // always main activity
      const dataInputs = data.getExecutionInputRecommendations.inputs.map(
        (file: any) => ({
          repositoryId: activityData?.mainRepository?.id,
          versionId: "",
          absolutePath: `${file.repoName}/${file.path}`
        })
      );
      if (dataInputs.length > 0) {
        setExecutionInput(dataInputs);
      }
    });
    if (notCloneJob) {
      getImageRecommendation({
        variables: {
          environmentId: variables.environmentId,
          repoName: repoName,
          path: fileName
        }
      }).then(({ data }: any) => {
        if (data.getExecutionImageRecommendations.images.length > 0) {
          const image =
            data.getExecutionImageRecommendations.images[0].toString();
          setExecutionImage({ id: image });
          setCustomCommand(getCommandRecommendation(image));
        }
      });
    }
  }
};
